import script from "./GridPropertiesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridPropertiesComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridPropertiesComponent.vue?vue&type=style&index=0&id=57435bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57435bb8"]])

export default __exports__